import {
  CheckOutlined,
  ClockCircleFilled,
  CloseOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

const treatmentTypeLookup = [
  { value: 1, label: "FUE Hair Transplant" },
  { value: 2, label: "PRP treatment" },
  { value: 3, label: "Prescription Medications" },
];
const treatmentTypeLookup2 = [
  { id: 1, name: "FUE Hair Transplant" },
  { id: 2, name: "PRP treatment" },
  { id: 3, name: "Prescription Medications" },
];
const recipentAreaLookup = [
  { value: 1, label: "Temples" },
  { value: 2, label: "Front" },
  { value: 3, label: "Mid scalp" },
  { value: 4, label: "Crown/vertex" },
];
const appointmentStatusLookup = [
  { id: 1, name: "All" },
  { id: 2, name: "Pending" },
  { id: 5, name: "Confirmed" },
  { id: 3, name: "Completed" },
  { id: 4, name: "Cancel" },
];
const prpSessionLookup = [
  { id: 2, name: "Pending" },
  { id: 3, name: "Completed" },
  { id: 4, name: "Cancel" },
];
const priorityLookup = [
  { id: 1, name: "All" },
  { id: 2, name: "Low" },
  { id: 3, name: "Normal" },
  { id: 4, name: "High" },
  { id: 5, name: "Urgent" },
];
const priorityLookup2 = [
  { value: 1, label: "Low" },
  { value: 2, label: "Normal" },
  { value: 3, label: "High" },
  { value: 4, label: "Urgent" },
];
const sourceLookup = [
  { id: "Referred by friend", name: "Referred by friend" },
  { id: "Facebook Page", name: "Facebook Page" },
  { id: "Twitter", name: "Twitter" },
  { id: "Instagram", name: "Instagram" },
  { id: "Tiktok", name: "Tiktok" },
  { id: "Website", name: "Website" },
  { id: "Self Search", name: "Self Search" },
  { id: "Sign Board", name: "Sign Board" },
  { id: "Google ADs", name: "Google ADs" },
  { id: "Facebook ADs", name: "Facebook ADs" },
  { id: "Tiktok ADs", name: "Tiktok ADs" },
  { id: "Other", name: "Other" },
];

const biChoiseLookup = [
  { id: 1, name: "Yes" },
  { id: 2, name: "No" },
];
const PRPSessionStatusLookup = [
  { value: 1, icon: <ClockCircleFilled />, label: "pending" },
  { value: 2, icon: <CheckOutlined />, label: "Session done" },
  { value: 3, icon: <CloseOutlined />, label: "cancel Session" },
  { value: 4, icon: <DeleteOutlined />, label: "Delete Session" },
];

const clientPriorityOps = [
  // {
  //   id: "",
  //   name: "All",
  // },
  {
    id: "Low",
    name: "Low",
  },
  {
    id: "Normal",
    name: "Normal",
  },
  {
    id: "High",
    name: "High",
  },
  {
    id: "Urgent",
    name: "Urgent",
  },
];

const followUpStatus = [
  // {
  //   id: "",
  //   name: "All",
  // },
  {
    id: "Pending",
    name: "Pending",
  },
  {
    id: "Called",
    name: "Called",
  },
  {
    id: "Appointment scheduled",
    name: "Appointment Scheduled",
  },
  {
    id: "Not interested",
    name: "Not interested",
  },
  {
    id: "No response",
    name: "No Response",
  },
  {
    id: "Callback required",
    name: "Callback Required",
  },
];

const appointmentStatusOptions = [
  // { label: "All", value: "ALL" },
  { label: "Pending", value: "pending" },
  { label: "Completed", value: "completed" },
  { label: "Cancelled", value: "cancel" },
];

export {
  treatmentTypeLookup,
  treatmentTypeLookup2,
  recipentAreaLookup,
  appointmentStatusLookup,
  prpSessionLookup,
  priorityLookup,
  priorityLookup2,
  sourceLookup,
  biChoiseLookup,
  PRPSessionStatusLookup,
  clientPriorityOps,
  followUpStatus,
  appointmentStatusOptions,
};
